









































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {AppConfig} from '@/config/app.config'
import FilterToggle from '@/components/FilterToggle.vue'
import ReportsIRouteIndicatorResponse from '@/model/response/ReportsIRouteIndicatorResponse'
import * as Helper from '@/helpers'
import {snakeCase} from 'lodash'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'

const metaInfo = () => ({
  title: $.t('view.reportIRoute.title'),
})

@Component({
  metaInfo,
  components: {FilterDelivery, FilterToggle},
})
export default class ReportsIRouteIndicatorView extends Mixins(MixinFilter) {
  filter = new DeliveryRequest()
  collection = new PageCollection(
    ReportsIRouteIndicatorResponse,
    this.filter,
    10,
  )

  AppConfig = AppConfig

  async downloadData(xlsx: boolean) {
    ReportsIRouteIndicatorResponse.isReport = true
    if (xlsx) {
      await $.await.run(
        () => {
          return Helper.downloadXlsx(
              $.t('view.reportIRoute.title'),
              new ReportsIRouteIndicatorResponse().$endpoint,
              this.filter,
              ReportsIRouteIndicatorResponse,
              'ReportsIRouteIndicatorResponse',
          )
        },
        'download',
      )
      ReportsIRouteIndicatorResponse.isReport = false
    } else {
      const csv = new PageCollection(
        ReportsIRouteIndicatorResponse,
        this.filter,
        null,
        null,
      )

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reportIRoute.title')))
      ReportsIRouteIndicatorResponse.isReport = false
    }
  }

  async created() {
    this.collection.orderBy = 'danfe'
    this.collection.asc = false
  }
}
